import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';
import { DataService } from '../service/data.service';
import { WorkflowService } from '../service/workflow/workflow.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent extends BaseComponent implements OnInit {

  constructor(dataService: DataService, private workflowService: WorkflowService) {
    super(dataService);
  }

  ngOnInit() {    
  }

}
